module.exports = __webpack_public_path__ + "files/b683bb2a73dff49849bd5c0de5499e69.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-16x16.png
// module id = 308
// module chunks = 27